export default __webpack_public_path__ + "static/media/house_square_footage.e435d61b.svg";